import API from "../utils/api";
import _ from 'lodash'

export const ACTION_TYPES = {
    USER_CREATE: 'USER_CREATE',
    USER_UPDATE: 'USER_UPDATE',
    USER_DELETE: 'USER_DELETE',
    USER_FETCH: 'USER_FETCH',
    USER_FETCH_ALL: 'USER_FETCH_ALL',
    USER_PAGINATION: 'USER_PAGINATION',
    USER_CART_UPDATE: 'USER_CART_UPDATE',
    USER_CART: 'USER_CART'
}

export const fetchAll = () => dispatch => {
    API.user().fetchAll()
        .then(res => {
            dispatch({
                type: ACTION_TYPES.USER_FETCH_ALL,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const Pagination = (page = 1, limit = 5, firstName = "", email = "") => dispatch => {
    API.user().fetchPagination(page, Math.abs(limit), firstName, email)
        .then(res => {

            dispatch({
                type: ACTION_TYPES.USER_PAGINATION,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const fetchById = (id, onSuccess) => dispatch => {
    API.user().fetchById(id)
        .then(res => {
            dispatch({
                type: ACTION_TYPES.USER_FETCH,
                payload: res.data
            })
            onSuccess(res.data)
        })
        .catch(err => console.log(err))
}

export const fetchCart = (id) => dispatch => {
    API.user().fetchById(id)
        .then(res => {

            var count = {};
            res.data.cart.forEach(function (i) { count[i] = (count[i] || 0) + 1; });
            let cartObj = {
                cart: count,
                cartArray: res.data.cart,
                coupons: res.data.coupons
            }
            dispatch({
                type: ACTION_TYPES.USER_CART_UPDATE,
                payload: cartObj
                // payload: res.data.cart
            })
        })
        .catch(err => console.log(err))
}

export const create = (input, onSuccess) => dispatch => {
    API.user().create(input)
        .then(res => {
            dispatch({
                type: ACTION_TYPES.USER_CREATE,
                payload: res.data
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}

export const update = (id, input) => dispatch => {

    API.user().update(id, input)
        .then(res => {

            dispatch({
                type: ACTION_TYPES.USER_UPDATE,
                payload: res.data
            })
            // onSuccess()
        })
        .catch(err => console.log(err))
}

export const updateCart = (id, input, onSuccess) => dispatch => {
    if (input == null) {
        return;
    }
    
    API.user().updateCart(id, input)
        .then(res => {
           // console.log('qqq---------------->',res.data)
            let unfilteredCart = _.filter(res.data.cart, data => data?.branch === localStorage.getItem("currentBranch"))
            let filteredcart = unfilteredCart.flatMap(i => i.id)
            var count = {};
            filteredcart.forEach(function (i) { count[i] = (count[i] || 0) + 1; });
            let cartObj = {
                cart: count,
                cartArray: filteredcart,
                coupons: res.data.coupons
            }

            global.cartBadge = _.uniq(filteredcart).length

            dispatch({
                type: ACTION_TYPES.USER_CART_UPDATE,
                payload: cartObj
                // payload: res.data.cart
            })
            onSuccess(cartObj)
        })
        .catch(err => console.log(err))
}

export const Delete = (id, onSuccess) => dispatch => {
    API.user().delete(id)
        .then(res => {

            dispatch({
                type: ACTION_TYPES.USER_DELETE,
                payload: res.data.id
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}

export const getCart = (param) => dispatch => {

    API.user().getCart(param)
        .then(res => {

            dispatch({
                type: ACTION_TYPES.USER_CART,
                payload: res.data[0].cart,
                coupons: res.data[0].coupons
            })
            //  onSuccess(res.data)
        })
        .catch(err => console.log(err))
}